import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[libDragAndDrop]',
  standalone: false,
})
export class DragAndDropDirective {
  @Input() isUploadDisabled: boolean;
  @Output() fileDropped = new EventEmitter<unknown>();

  counter = 0;

  constructor(private element: ElementRef) {}

  // dragenter listener
  @HostListener('dragenter', ['$event'])
  onDragEnter(evt) {
    this.counter++;
    evt.preventDefault();
    evt.stopPropagation();

    if (this.isUploadDisabled) {
      return;
    }
    this.element.nativeElement.classList.add('dragover');
  }

  // dragover listener
  @HostListener('dragover', ['$event'])
  onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  // Dragover listener
  @HostListener('dragleave', ['$event'])
  onDragLeave(evt) {
    this.counter--;
    evt.preventDefault();
    evt.stopPropagation();

    if (this.isUploadDisabled) {
      return;
    }

    if (this.counter === 0) {
      this.element.nativeElement.classList.remove('dragover');
    }
  }

  // Drop listener
  @HostListener('drop', ['$event'])
  onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    if (this.isUploadDisabled) {
      return;
    }

    this.element.nativeElement.classList.remove('dragover');
    this.counter--;

    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropped.emit(files);
    }
  }
}
